import { Routes, Route } from "react-router-dom";
import VatCodes from "./VatCodes";
import VatCodeCreateEdit from "./VatCodeCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<VatCodes />} />
			<Route path='/create' element={<VatCodeCreateEdit />} />
			<Route path='/:id/edit' element={<VatCodeCreateEdit />} />
		</Routes>
	);
};

export default index;
